(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banner-slider"] && !Shopify.designMode) return;
  try {
    
    function setSwiperHeight(swiperClass) {
      const swiperEl = document.querySelector(swiperClass);
      const firstImg = swiperEl?.querySelector('.swiper-slide img');
      if (firstImg && swiperEl) {
        const setHeight = () => {
          swiperEl.style.height = firstImg.clientHeight + 'px';
        };
        if (firstImg.complete) {
          setHeight();
        } else {
          firstImg.onload = setHeight;
        }
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const desktopSwiper = new Swiper('.desktop-swiper', {
        loop: true,
        speed: 600,
        effect: 'slide',
        autoplay: { delay: 3000, disableOnInteraction: false }
      });

      window.addEventListener('load', function () {
    const mobileSwiper = new Swiper('.mobile-swiper', {
      loop: true,
      speed: 500,
      effect: 'fade',
      autoplay: { delay: 2500, disableOnInteraction: false }
    });
  });


      function updateBannerHeights() {
        if (window.innerWidth > 767) {
          setSwiperHeight('.desktop-swiper');
        } else {
          setSwiperHeight('.mobile-swiper');
        }
      }

      updateBannerHeights();

      window.addEventListener('resize', updateBannerHeights);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initSwatchOptionImage();
              window.initVariantChanger(this);
              window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
              window.initCompare();
            }
      const   swiperItems = document.querySelectorAll('.product-recommendations'),
              sliderOptions = $(swiperItems).attr('data-slider-options'),
               slideroptionConfig = $.parseJSON(sliderOptions),
               recommedndationSlider = new Swiper(".product-recommendations", slideroptionConfig);
               $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js"); 
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
